import Script from 'next/script';

type Props = {
  asPath: string;
};

/**
 * Recurly script.
 */
const ConvertExperimentsScript = ({ asPath: pathname }: Props) => {
  const shouldRenderScript =
    pathname === '/' ||
    pathname.startsWith('/plans') ||
    pathname.startsWith('/buy') ||
    pathname.startsWith('/deal');

  if (!shouldRenderScript) return null;

  return (
    <Script
      type="text/javascript"
      data-testid="convertexperiments-script"
      src="//cdn-4.convertexperiments.com/js/10041278-10045436.js"
    />
  );
};

export default ConvertExperimentsScript;
